import styled from 'styled-components';

/**
 * Reset only — no size or placement. Consumers wrap this with `styled()` and
 * supply their own position and font-size, so anything set here that they also
 * set would just be dead weight.
 */
export const Button = styled.button`
  background: transparent;
  border: none;
  padding: 0.4rem 0.8rem;
  line-height: 1;
  font-family: inherit;
  color: ${({ theme }) => theme.colors.slateGrey};
  cursor: pointer;
`;
